module.exports = __webpack_public_path__ + "static/media/search age wise.4e3f6e63.svg";